namespace RedBullMOBILE360.CustomerCare {
    export interface BlockedSMSCustomersForm {
        Msisdn: Serenity.StringEditor;
        CreationDate: Serenity.DateEditor;
    }

    export class BlockedSMSCustomersForm extends Serenity.PrefixedContext {
        static formKey = 'CustomerCare.BlockedSMSCustomers';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!BlockedSMSCustomersForm.init)  {
                BlockedSMSCustomersForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;

                Q.initFormType(BlockedSMSCustomersForm, [
                    'Msisdn', w0,
                    'CreationDate', w1
                ]);
            }
        }
    }
}
